<template>
  <BaseModal modalColor="border-success bg-primary" iconModal="fa fa-edit" subtitulo="Cadastrar nova análise"
             col-md="col-md-7" offset="offset-3">
    <template v-slot:modalContent>
      <form ref="cadastroForm" @submit.prevent="submitIncluirForm">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.cliente"
                    inputId="cliente"
                    :options="clientes"
                    optionLabel="razao_social"
                    optionValue="id"
                    size="small"
                    appendTo="body"
                    filter
                    style="width: 100%"
                    :invalid="campoVazio.includes('cliente')"
                >
                  <template #emptyfilter>
                    Nenhum resultado encontrado
                  </template>
                </Select>
                <label for="cliente">
                  <strong>Cliente:</strong> <span class="text-danger font-bold">*</span>
                </label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.imovel"
                    inputId="imovel"
                    :options="imoveis"
                    optionLabel="descricao"
                    optionValue="id"
                    size="small"
                    appendTo="body"
                    filter
                    style="width: 100%"
                    @update:modelValue="dadosImovelSelect"
                    :invalid="campoVazio.includes('imovel')"
                >
                  <template #emptyfilter>
                    Nenhum resultado encontrado
                  </template>
                </Select>
                <label for="imovel">
                  <strong>Imóvel:</strong> <span class="text-danger font-bold">*</span>
                </label>
              </FloatLabel>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.corretor"
                    inputId="corretor"
                    :options="corretores"
                    optionLabel="nome"
                    optionValue="id"
                    size="small"
                    appendTo="body"
                    filter
                    style="width: 100%"
                    :invalid="campoVazio.includes('corretor')"
                >
                  <template #emptyfilter>
                    Nenhum resultado encontrado
                  </template>
                </Select>
                <label for="corretor">
                  <strong>Corretor:</strong> <span class="text-danger font-bold">*</span>
                </label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <Select
                    v-model="dado.tipo_imovel"
                    inputId="tipo_imovel"
                    :options="tipoImovel"
                    optionLabel="label"
                    optionValue="value"
                    size="small"
                    appendTo="body"
                    style="width: 100%"
                    disabled
                />
                <label for="tipo_imovel"><strong>Tipo Imóvel: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputNumber id="valor" v-model="dado.valor" size="small" style="width: 100%" disabled
                             :minFractionDigits="2" :maxFractionDigits="5" fluid :inputStyle="{ textAlign: 'right' }"/>
                <label for="valor"><strong>Valor do Imóvel: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputText id="analista" v-model="dado.analista" size="small" style="width: 100%"
                           :invalid="campoVazio.includes('analista')"/>
                <label for="analista"><strong>Análista: <span class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <InputNumber id="valor_financiamento" v-model="dado.valor_financiamento" size="small"
                             style="width: 100%" :invalid="campoVazio.includes('valor_financiamento')"
                             :minFractionDigits="2" :maxFractionDigits="5" fluid :inputStyle="{ textAlign: 'right' }"/>
                <label for="valor_financiamento"><strong>Valor do Financiamento: <span
                    class="text-danger font-bold">*</span></strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <FloatLabel variant="on">
                <DatePicker id="data_avaliacao" v-model="dado.data_avaliacao" showIcon iconDisplay="input"
                            size="small" style="width: 100%" appendTo="body" ref="dataAvaliacao"
                            dateFormat="dd/mm/yyyy"/>
                <label for="data_avaliacao"><strong>Data Avaliação: </strong></label>
              </FloatLabel>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <FloatLabel variant="on">
                <Textarea id="observacao" v-model="dado.observacao" rows="2" cols="47"/>
                <label for="observacao"><strong>Observação: </strong></label>
              </FloatLabel>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <FloatLabel variant="on">
                <Textarea id="descritivo" v-model="dado.descritivo" rows="4" cols="47" disabled/>
                <label for="descritivo"><strong>Descritivo: </strong></label>
              </FloatLabel>
            </div>
          </div>
        </div>
        <div class="ibox-footer">
          <div class="float-right">
            <button type="submit" class="btn btn-primary font-bold">Confirmar</button>
          </div>
          <button class="btn btn-danger font-bold" @click="$emit('fechar')">
            Cancelar
          </button>
        </div>
      </form>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import {apiRequest, denormalizeDates} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";


export default {
  name: "CadastrarAnalises",
  components: {
    BaseModal,
  },
  data() {
    return {
      clientes: [],
      imoveis: [],
      corretores: [],
      dado: {
        cliente: "",
        imovel: "",
        corretor: "",
        descritivo: "",
        observacoes: "",
        data_cadastro: null,
        data_avaliacao: null,
        tipo_imovel: "",
        valor: "",
        valor_financiamento: "",
        analista: "",
      },
      campoVazio: [],
      tipoImovel: [
        {label: 'CONSTRUIDO', value: 'C'},
        {label: 'NA PLANTA', value: 'N'}
      ],
    }
  },
  emits: ["fechar", "atualizarLista"],
  methods: {
    parseMoeda(valor) {
      if (!valor) return 0;
      return Number(valor.replace(/\./g, "").replace(",", "."));
    },
    dadosImovelSelect() {
      const imovelSelecionado = this.imoveis.find(
          (imovel) => imovel.id === this.dado.imovel
      );
      if (imovelSelecionado) {
        if (imovelSelecionado.tipo_imovel === 'CONSTRUIDO') {
          this.dado.tipo_imovel = 'C';
        } else {
          this.dado.tipo_imovel = 'N';
        }
        this.dado.valor = this.parseMoeda(imovelSelecionado.valor);
        this.dado.descritivo = imovelSelecionado.descritivo;
      }
    },
    async getClientes() {
      const resultado = await apiRequest("GET", `${apiUrl.clientes.createList}?status=A`);
      if (resultado.success) {
        this.clientes = resultado.data.results;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async getImoveis() {
      const resultado = await apiRequest("GET", `${apiUrl.imoveis.createList}?status=D`);
      if (resultado.success) {
        this.imoveis = resultado.data.results;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async getCorretores() {
      const resultado = await apiRequest("GET", `${apiUrl.corretores.createList}?status=A`);
      if (resultado.success) {
        this.corretores = resultado.data.results;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async submitIncluirForm() {
      denormalizeDates(this.dado, ['data_avaliacao']);
      const resultado = await apiRequest("POST", apiUrl.analises.createList, this.dado);
      if (resultado.success) {
        this.$emit("atualizarLista", resultado.data);
        this.$toastMessage("success", "Registro salvo com sucesso!");
        this.$emit('fechar');
      } else {
        this.campoVazio = Object.keys(resultado.error);
        if (resultado.error && typeof resultado.error === "object") {
          for (const campo in resultado.error) {
            resultado.error[campo].forEach(msg => {
              this.$toastMessage("error", campo, msg);
            });
          }
        } else {
          this.$toastMessage("warn", "Atenção", "Erro inesperado ao salvar!");
        }
      }
    },
  },
  mounted() {
    this.getClientes();
    this.getImoveis();
    this.getCorretores();
    Inputmask("99/99/9999").mask(this.$refs.dataAvaliacao.$el.querySelector("input"));
  }
}
</script>
